import React from "react";
import ReactDOM from "react-dom";

const VIDEO_SOURCES = {
  1: {
    src: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/meme-video-1.mp4",
    poster: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-peer-sister.webp",
  },
  2: {
    src: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/meme-video-2.mp4",
    poster: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-peer-brother.webp",
  },
};

const MemeVideoModal = ({ open, onClose, videoId }) => {
  if (!open) return null;

  const video = VIDEO_SOURCES[videoId];
  if (!video) return null;

  return (
    <div style={{ display: open ? 'flex' : 'none' }} className='select-archetype-modal-container'>
            <div className="select-archetype-modal-overlay" onClick={() => onClose()}></div>
            <div className="select-archetype-modal">
                <div className="select-archetype-modal-header">
                    <button className="select-archetype-modal-close-button" onClick={() => onClose()} style={{position: "absolute", top: "10px", right: "10px", background: "none", border: "none", cursor: "pointer"}}>❌</button>
                </div>
                <div className="select-archetype-modal-body">
                   <video
                        key={videoId}
                        controls
                        autoPlay
                        playsInline
                        poster={video.poster}
                        className="meme-video-modal__video"
                    >
                        <source src={video.src} type="video/mp4" />
                    </video>
                </div>
            </div>
        </div>
  );
};

export default MemeVideoModal;